import React from "react";
import { NavLink } from "react-router-dom";
import MarketingBanner from "../../assets/images/marketing-prof/marketing-prof-banner.png";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import AutoTarget from "../../assets/images/marketing-prof/autoTarget.png";
import omniChannel from "../../assets/images/marketing-prof/omnichennal.png";
import dataDrivenInsights from "../../assets/images/marketing-prof/dataDrivenInsights.png";
import automatedLeadGen from "../../assets/images/marketing-prof/automatedLeadGen.png";
import seamlessInteg from "../../assets/images/marketing-prof/seamless-integ.png";
import contentPerson from "../../assets/images/marketing-prof/content-person.png";
import enhancedEffi from "../../assets/images/marketing-prof/enhnced-effi.svg";
import improvedLeadQuality from "../../assets/images/marketing-prof/imprvd-lead-quality.svg";
import greaterROI from "../../assets/images/marketing-prof/greaterRoi.svg";
import scalableCamp from "../../assets/images/marketing-prof/scalable-camp.svg";

const MarketingPage = () => {
  const gap24px = "24px";
  const gap60px = "60px";

  return (
    <>
      <div className="marketing-main-wrapper">
        <section className="ma-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb10 text-color-131415">
                    The Essential <br /> Tool for Marketing <br /> Professionals
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Marketing professionals can harness BeyondLeadz <br /> data
                    to generate more leads by leveraging detailed <br />{" "}
                    customer data and behavior insights.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Subscribe Now
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/contact-us"}
                        className="common-btn-class transparentBtn roboto-regular"
                      >
                        Contact us
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={MarketingBanner}
                    className="img-responsive"
                    alt="The Ultimate Tool for Sales Professionals"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb10 heading29px mb40 text-center">
                Why Marketing Professionals Should Use BeyondLeadz
              </h2>
              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Precise Audience Targeting
                  </h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz allows you to build highly targeted lists based
                    on demographics, behaviors, and interests. Whether you’re
                    launching a new campaign or refining an existing one, our
                    tools ensure you’re reaching the right people, at the right
                    time, with the right message.
                  </p>
                </div>
                <div>
                  <img
                    src={AutoTarget}
                    alt="Precise Audience Targeting"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={omniChannel}
                    alt="Omnichannel Campaign Management"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Omnichannel Campaign Management
                  </h3>
                  <p className="heading16px roboto-regular">
                    Manage all your marketing channels—email, social media, web,
                    and more—from a single, integrated platform. Coordinate
                    campaigns across multiple touchpoints to create a cohesive
                    and consistent brand experience.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Data-Driven Insights
                  </h3>
                  <p className="heading16px roboto-regular">
                    Make informed decisions with real-time analytics and
                    reporting. Track campaign performance, monitor key metrics,
                    and gain insights into what’s working and what’s not, so you
                    can optimize your strategies for maximum impact.
                  </p>
                </div>
                <div>
                  <img
                    src={dataDrivenInsights}
                    alt="Data-Driven Insights"
                    className="img-responsive"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="block-order2">
                  <img
                    src={automatedLeadGen}
                    alt="Automated Lead Nurturing"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Automated Lead Nurturing
                  </h3>
                  <p className="heading16px roboto-regular">
                    Set up automated workflows to nurture leads through the
                    funnel, delivering personalized content and messages based
                    on their interactions with your brand. BeyondLeadz helps you
                    keep leads engaged and moving toward conversion without
                    manual intervention.
                  </p>
                </div>
              </div>

              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Seamless Integrations
                  </h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz integrates with your favorite marketing tools
                    and platforms—like Gmail, Facebook, LinkedIn, and
                    more—ensuring your data flows seamlessly across systems,
                    saving you time and reducing errors.
                  </p>
                </div>
                <div>
                  <img
                    src={seamlessInteg}
                    alt="Seamless Integrations"
                    className="img-responsive"
                  />
                </div>
              </div>

              <div className="grid-auto-fit align-items-center max-width950">
                <div className="block-order2">
                  <img
                    src={contentPerson}
                    alt="Content Personalization"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Content Personalization
                  </h3>
                  <p className="heading16px roboto-regular">
                    Use enriched data to create personalized marketing content
                    that resonates with your audience. Leadz helps you tailor
                    your messaging to meet the unique needs and preferences of
                    each segment, increasing engagement and conversion rates.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="benefits-for-marketing">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Benefits for Marketing Professionals
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": "repeat(2, 1fr)",
                  "--grid-gap": "24px",
                }}
              >
                <div className="common-white-box common-shadow">
                  <img
                    src={enhancedEffi}
                    className="img-responsive position-relative"
                    alt="Enhanced Efficiency"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Enhanced Efficiency
                  </h3>
                  <p className="roboto-regular heading16px">
                    Streamline your marketing processes with automation, freeing
                    up more time for creative and strategic work.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={improvedLeadQuality}
                    className="img-responsive position-relative"
                    alt="Improved Lead Quality"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Improved Lead Quality
                  </h3>
                  <p className="roboto-regular heading16px">
                    Capture and nurture high-quality leads, ensuring that your
                    sales team is only working with the most promising
                    prospects.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={greaterROI}
                    className="img-responsive position-relative"
                    alt="Greater ROI"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Greater ROI
                  </h3>
                  <p className="roboto-regular heading16px">
                    Optimize your marketing spend by focusing on strategies and
                    channels that deliver the best results, all backed by
                    data-driven insights.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={scalableCamp}
                    className="img-responsive position-relative"
                    alt="Scalable Campaigns"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Scalable Campaigns
                  </h3>
                  <p className="roboto-regular heading16px">
                    Easily scale your marketing efforts, whether you’re
                    launching a small targeted campaign or a large,
                    multi-channel initiative.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Testimonials />
      </div>

      {/* <div className="sales-wrapper">
                <section className="sales-banner">
                    <div className="max-container">
                        <div className="padd-90">
                            <div className="grid-auto-fit align-items-center">
                                <div>
                                    <h1 className="heading39px roboto-bold mb10 text-color-131415">
                                        Marketers, your CEO will thank you.
                                    </h1>
                                    <p className="heading16px roboto-regular mb30">Whatever your role, BeyondLeadz's marketing intelligence <br />
                                        platform helps you perform better at every stage of <br />
                                        the sales process.</p>

                                    <ul className="btn-sec">
                                        <li>
                                            <NavLink to={"/signup"} className="common-btn-class main-btn-primary roboto-regular"> Subscribe Now</NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={"/contact-us"} className="common-btn-class main-btn-primary roboto-regular">Contact us</NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <img src={BannerImage2} className="img-responsive position-relative" alt="Double Your Qualified Leads" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="clients-row _border-bottom bck-color-fafafa">
                    <div className="max-container">
                        <div className="grid-auto-fit align-items-center">
                            <div className="text-center">
                                <img src={TataImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={CanonImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={DellImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={PanasonicImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={BimtechImage} alt="Clients" className="img-responsive" />
                            </div>

                            <div className="text-center">
                                <img src={AirtelImage} alt="Clients" className="img-responsive" />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bck-color-fafafa">
                    <div className="max-container">
                        <div className="padd-90">
                            <div className="text-center mb40">
                                <h2 className="roboto-bold mb10 heading29px">Here’s how BeyondLeadz can help you</h2>

                                <p className="heading16px roboto-regular ">
                                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.  Lorem ipsum, dolor sit amet  <br /> consectetur adipisicing elit.
                                </p>

                            </div>

                            <div className="grid-auto-fit" style={{ '--grid-gap': gap24px }}>
                                <div>
                                    <div className="common-white-box common-shadow s-feat-box">
                                        <div className="card-front">
                                            <h3 class="heading20px roboto-bold">Demand Gen Specialist</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Supply leads that convert</p>
                                            <p className="roboto-regular heading15px text-primary-color">See More</p>
                                            <img src="https://www.lusha.com/wp-content/uploads/2023/08/card-1-3.png" alt="img-responsive" />
                                        </div>

                                        <div className="card-back">
                                            <h3 class="heading20px roboto-bold">Demand Gen Specialist</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Supply leads that convert</p>

                                            <ul className="points-ul mb40">
                                                <li className="heading14px roboto-regular text-color-131415">Quickly and easily find verified contact information</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="common-white-box common-shadow s-feat-box">
                                        <div className="card-front">
                                            <h3 class="heading20px roboto-bold">Marketing Manager</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Know your audience’s needs</p>
                                            <p className="roboto-regular heading15px text-primary-color">See More</p>
                                            <img src="https://www.lusha.com/wp-content/uploads/2023/08/card-2-2.png" alt="img-responsive" />
                                        </div>

                                        <div className="card-back">
                                            <h3 class="heading20px roboto-bold">Marketing Manager</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Know your audience’s needs</p>

                                            <ul className="points-ul mb40">
                                                <li className="heading14px roboto-regular text-color-131415">Quickly and easily find verified contact information</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="common-white-box common-shadow s-feat-box">
                                        <div className="card-front">
                                            <h3 class="heading20px roboto-bold">Director of Marketing</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Strategize with data that delivers</p>
                                            <p className="roboto-regular heading15px text-primary-color">See More</p>
                                            <img src="https://www.lusha.com/wp-content/uploads/2023/08/card-3-2.png" alt="img-responsive" />
                                        </div>

                                        <div className="card-back">
                                            <h3 class="heading20px roboto-bold">Director of Marketing</h3>
                                            <p className="text-color-a39f9f heading15px roboto-regular mb10">Strategize with data that delivers</p>

                                            <ul className="points-ul mb40">
                                                <li className="heading14px roboto-regular text-color-131415">Quickly and easily find verified contact information</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                                <li className="heading14px roboto-regular text-color-131415">Improve the accuracy of your data with Lusha’s data enrichment</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >

                <section className="">
                    <div className="max-container">
                        <div className="padd-90">
                            <h2 className="roboto-bold mb10 heading29px mb40 text-center">"It’s like you read my mind!” - Your leads…probably.</h2>
                            <div className="grid-auto-fit align-items-center" style={{ '--grid-gap': gap60px }}>
                                <div>
                                    <h3 className="heading20px roboto-bold mb10">Meet your top prospects right
                                    when they need you</h3>
                                    <p className="heading16px roboto-regular mb20">Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks. panies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search.</p>
                                    <p className="heading16px roboto-regular">right companies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks.</p>
                                </div>
                                <div>
                                    <img src="https://www.lusha.com/wp-content/uploads/2023/07/leads-at-scale-588x520-1.png" alt="img" className="img-responsive" />
                                </div>
                            </div>

                            <div className="grid-auto-fit align-items-center" style={{ '--grid-gap': gap60px }}>
                                <div className="block-order2">
                                    <img src="https://www.lusha.com/wp-content/uploads/2023/07/leads-at-scale-588x520-1.png" alt="img" className="img-responsive" />
                                </div>
                                <div>
                                    <h3 className="heading20px roboto-bold mb10">The enriched get richer</h3>
                                    <p className="heading16px roboto-regular mb20">Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks. panies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search.</p>
                                    <p className="heading16px roboto-regular">right companies and leads with Beyond Leadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks.</p>

                                </div>
                            </div>

                            <div className="grid-auto-fit align-items-center" style={{ '--grid-gap': gap60px }}>
                                <div>
                                    <h3 className="heading20px roboto-bold mb10">Targeting the right audience
                                    has never been easier</h3>
                                    <p className="heading16px roboto-regular mb20">Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks. panies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search.</p>
                                    <p className="heading16px roboto-regular">right companies and leads with BeyondLeadz Prospect Search Cut hours of researching the right companies and leads with BeyondLeadz Prospect Search. Load up thousands of leads with accurate firmographic data in just a few clicks.</p>
                                </div>
                                <div>
                                    <img src="https://www.lusha.com/wp-content/uploads/2023/07/leads-at-scale-588x520-1.png" alt="img" className="img-responsive" />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <Subscribe />
            </div > */}
    </>
  );
};

export default MarketingPage;
